import clsx from "clsx";
import DebounceInput from "../DebounceInput/DebounceInput";

export type NumberInputProps = {
  value?: number;
  onChange?: (value?: number) => void;
  unit?: string;
  min?: number;
  max?: number;
  step?: number;
  placeholder?: string;
  error?: boolean;
  className?: string;
  disabled?: boolean;
};

function NumberInput({
  value,
  onChange,
  unit,
  min,
  max,
  step,
  placeholder,
  error,
  className,
  disabled,
}: NumberInputProps) {
  const handleChange = (val: any) => {
    if (val === "" || val === "-" || val === ".") {
      onChange?.(undefined);
      return;
    }

    const parsed = Number(val);
    if (!Number.isNaN(parsed)) {
      onChange?.(parsed);
    }
  };

  const containerClassName = clsx(className, unit && "pr-10");

  return (
    <div className="relative flex items-center gap-4">
      <DebounceInput
        type="number"
        value={value?.toString()}
        onChange={handleChange}
        placeholder={placeholder}
        min={min}
        max={max}
        step={step}
        inputMode="decimal"
        error={error}
        className={containerClassName}
        disabled={disabled}
      />

      {unit && (
        <span className="text-sm text-slate-500 pointer-events-none">
          {unit}
        </span>
      )}
    </div>
  );
}

export default NumberInput;
